import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import { iso, monthStart } from "../../lib/dates";
import { Notice, Stat } from "../../lib/ui";

/* Compare two products' sales – port of sales-report.php (API: /api/sales/compare) */

export default function CompareProducts() {
  const api = useApi();
  const [f, setF] = useState({ date_from: iso(monthStart(new Date())), date_to: iso(new Date()), p1: "", p2: "" });
  const [products, setProducts] = useState([]);
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/sales/compare").then((r) => setProducts(r.products)).catch((e) => setError(e.message)); }, [api]);
  const run = (e) => {
    e.preventDefault();
    api.get("/api/sales/compare", { date_from: f.date_from, date_to: f.date_to, products: [f.p1, f.p2].filter(Boolean).join(",") }).then(setD).catch((er) => setError(er.message));
  };
  const opt = products.map((p) => <option key={p.product_id} value={p.product_id}>{p.product_name}{p.manufacturer ? ` (${p.manufacturer})` : ""}</option>);
  const s = d?.summary;
  return (
    <main className="pg">
      <PageHeader slug="sales-report" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={run}>
          <div className="field grow"><label htmlFor="cp-1">First product</label><select id="cp-1" required value={f.p1} onChange={(e) => setF({ ...f, p1: e.target.value })}><option value="">Choose</option>{opt}</select></div>
          <div className="field grow"><label htmlFor="cp-2">Second product (optional)</label><select id="cp-2" value={f.p2} onChange={(e) => setF({ ...f, p2: e.target.value })}><option value="">None</option>{opt}</select></div>
          <div className="field"><label htmlFor="cp-f">From</label><input id="cp-f" type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} /></div>
          <div className="field"><label htmlFor="cp-t">To</label><input id="cp-t" type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} /></div>
          <button type="submit" className="btn primary">Generate report</button>
        </form>
      </section>
      {d && (!s ? <div className="panel empty"><i className="fas fa-inbox" />No sales for the chosen product(s) in this period.</div> : (
        <>
          <div className="ui-stats">
            <Stat icon="fa-coins" tone="up" label="Revenue" value={n0(s.total_revenue)} unit="TZS" />
            <Stat icon="fa-sack-dollar" label={`Profit · margin ${s.avg_profit_margin.toFixed(1)}%`} value={n0(s.total_profit)} unit="TZS" />
            <Stat icon="fa-cubes" tone="muted" label={`Units · ${n0(s.total_sales)} sales`} value={n0(s.total_quantity)} />
          </div>
          <section className="panel"><div className="tbl-wrap"><table className="tbl">
            <thead><tr><th>Product</th><th className="num">Sales</th><th className="num">Units</th><th className="num">Revenue</th><th className="num">Profit</th><th className="num">Margin</th><th className="num">Avg price</th><th>First sale</th><th>Last sale</th></tr></thead>
            <tbody>{d.report.map((r) => <tr key={r.product_id}><td><b>{r.product_name}</b><div style={{ fontSize: ".72rem", color: "var(--muted)" }}>{r.manufacturer} {r.retail_unit ? `· ${r.retail_unit}` : ""}</div></td>
              <td className="num mono">{n0(r.number_of_sales)}</td><td className="num mono">{n0(r.total_quantity_sold)}</td><td className="num mono">{n2(r.total_revenue)}</td>
              <td className="num mono">{n2(r.total_profit)}</td><td className="num mono">{r.total_revenue > 0 ? ((r.total_profit / r.total_revenue) * 100).toFixed(1) : 0}%</td>
              <td className="num mono">{n2(r.avg_sale_price)}</td><td>{String(r.first_sale_date).slice(0, 10)}</td><td>{String(r.last_sale_date).slice(0, 10)}</td></tr>)}</tbody>
          </table></div></section>
        </>
      ))}
    </main>
  );
}
